import { type CombinedState, combineReducers, type Reducer } from "redux";
import type { AudioState } from "../Actions/Audio/AudioActions";
import type { CustomerDisplayState } from "../Actions/CustomerDisplay/CustomerDisplayActions";
import type { DialogState } from "../Actions/Dialogs/DialogActions";
import type { LayoutState } from "../Actions/General/LayoutActions";
import type { LocationState } from "../Actions/General/LocationActions";
import type { PresenceState } from "../Actions/General/PresenceActions";
import type { InformationState } from "../Actions/Information/InformationActions";
import type { NotificationState } from "../Actions/Notifications/NotificationActions";
import type { SynchronisationState } from "../Actions/Synchronisation/SynchronisationActions";
import type { UserState } from "../Actions/Users/UserActions";
import AudioReducer from "./General/AudioReducer";
import CustomerDisplayReducer from "./General/CustomerDisplayReducer";
import DialogReducer from "./General/DialogReducer";
import InformationReducer from "./General/InformationReducer";
import LayoutReducer from "./General/LayoutReducer";
import LocationReducer from "./General/LocationReducer";
import NotificationsReducer from "./General/NotificationsReducer";
import PresenceReducer from "./General/PresenceReducer";
import SynchronisationReducer from "./General/SynchronisationReducer";
import UserReducer from "./General/UserReducer";
import SellScreenReducer, { type SellScreenState } from "./SellScreen/SellScreenReducer";

export interface RootState {
    layout: LayoutState;
    notifications: NotificationState;
    dialog: DialogState;
    user: UserState;
    location: LocationState;
    sellscreen: SellScreenState;
    synchronisation: SynchronisationState;
    customerDisplay: CustomerDisplayState;
    information: InformationState;
    presence: PresenceState;
    audio: AudioState;
}

const ShopfrontReducers = (): Reducer<CombinedState<RootState>> => combineReducers<RootState>({
    layout         : LayoutReducer,
    notifications  : NotificationsReducer,
    dialog         : DialogReducer,
    user           : UserReducer,
    location       : LocationReducer,
    sellscreen     : SellScreenReducer,
    synchronisation: SynchronisationReducer,
    customerDisplay: CustomerDisplayReducer,
    information    : InformationReducer,
    presence       : PresenceReducer,
    audio          : AudioReducer,
});

export default ShopfrontReducers;
